/**
 * Batched note-count fetch for listing screens.
 *
 * Call once at the page level with the visible row IDs; pass the resulting
 * count down to each row's indicator as a prop. Batching avoids the N+1
 * query problem flagged in CR §1.2.5 / §4 risk register.
 *
 * Relocated from `components/notes/NoteIndicator.tsx` so it survives the v1
 * NoteIndicator's deletion in Phase 10.
 */
import { useQuery } from "@tanstack/react-query";

import { DBTables } from "@utils/constants/dbTables";
import { getNoteCounts } from "@services/notes";

export const useNoteCounts = (
  referenceTable: DBTables,
  referenceIds: string[],
) => {
  return useQuery(
    ["noteCounts", referenceTable, referenceIds.slice().sort().join(",")],
    () => getNoteCounts(referenceTable, referenceIds),
    {
      enabled: referenceIds.length > 0,
      keepPreviousData: true,
    },
  );
};
